export default __webpack_public_path__ + "static/media/open.7368826d.svg";